import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-506cb72f")

_pushScopeId("data-v-506cb72f")
const _hoisted_1 = { class: "wrpperFooter" }
const _hoisted_2 = { class: "search-card-footer" }
const _hoisted_3 = { class: "search-card-footer-price" }
const _hoisted_4 = { class: "search-card-footer-price__text" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Vat: ")
const _hoisted_6 = { class: "search-card-footer-price__text" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Сбор: ")
const _hoisted_8 = { class: "search-card-footer-price__text" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Цена: ")
const _hoisted_10 = { class: "search-card-footer-price__text" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" ИТОГ: ")
const _hoisted_12 = { class: "search-card-footer-controls" }
const _hoisted_13 = {
  key: 0,
  class: "subBlockRoom"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_hotel_room_tiket_small = _resolveComponent("hotel-room-tiket-small")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("p", _hoisted_4, [
          _hoisted_5,
          _createVNode("b", null, _toDisplayString(_ctx.extendedRatePrice.vat), 1)
        ]),
        _createVNode("p", _hoisted_6, [
          _hoisted_7,
          _createVNode("b", null, _toDisplayString(_ctx.extendedRatePrice.comparisionServiceFee) + " ₽", 1)
        ]),
        _createVNode("p", _hoisted_8, [
          _hoisted_9,
          _createVNode("b", null, _toDisplayString(_ctx.extendedRatePrice.comparisionOriginalPrice) + " ₽", 1)
        ]),
        _createVNode("p", _hoisted_10, [
          _hoisted_11,
          _createVNode("b", null, _toDisplayString(_ctx.extendedRatePrice.comparisionTotalPrice) + " ₽", 1)
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("button", {
          class: "search-card-footer-controls__dropdown",
          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.setShow(...args)))
        }),
        (_ctx.hasControl)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              (!_ctx.isModeOffer)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "search-card-footer-controls__submit",
                    onClick: _cache[2] || (_cache[2] = $event => (
              _ctx.toggleDisplay(_ctx.item && _ctx.item.accessKey ? _ctx.item.accessKey : null)
            ))
                  }, " Выбрать "))
                : _createCommentVNode("", true),
              (_ctx.isModeOffer && !_ctx.hasCansel)
                ? (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "search-card-footer-controls__submit",
                    onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.selectOffer(...args)))
                  }, " Выбрать "))
                : _createCommentVNode("", true),
              (_ctx.isModeOffer && _ctx.hasCansel)
                ? (_openBlock(), _createBlock("button", {
                    key: 2,
                    class: "search-card-footer-controls__submit",
                    onClick: _cache[4] || (_cache[4] = $event => (_ctx.unselect()))
                  }, " Отмена "))
                : _createCommentVNode("", true)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.show)
      ? (_openBlock(), _createBlock("div", _hoisted_13, [
          _createVNode(_component_hotel_room_tiket_small, {
            item: _ctx.item,
            isModeOffer: _ctx.isModeOffer,
            onSelectOffer: _ctx.selectOffer,
            hasControl: _ctx.hasControl
          }, null, 8, ["item", "isModeOffer", "onSelectOffer", "hasControl"])
        ]))
      : _createCommentVNode("", true)
  ]))
})